import angular from "angular";
import ordersList from "./components/orders-list/orders-list";

angular
    .module('orders', [
        ordersList
    ]);

export default 'orders';


// WEBPACK FOOTER //
// ./resources/assets/modules/orders/orders.module.js